import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	chatMessagesContainer: {
		padding: theme.spacing(1),
		flex: 1,
		overflowY: "auto",
		overflowX: "hidden",
		position: "absolute",
		top: 0,
		bottom: 0,
		width: "100%"
	},
	loadMoreMessagesButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[300]),
		fontSize: 14,
		boxShadow: "none",
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[400]),
			boxShadow: "none"
		}
	},
	scrollButtonArea: {
		position: "absolute",
		bottom: "5px",
		right: "10px"
	},
	roundedIconButton: {
		padding: "4px",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		opacity: 0.5,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
			opacity: 0.5
		}
	}
}))

export default useStyles
